<template>
  <div class="cosigner date-field">
    <StepHeader title="What Is Your Date of Birth?"/>
    <StepContent
      width="xs"
    >
      <AppDateInput
        label="MM / DD / YYYY"
        :value="value"
        :error="error"
        v-data-layer
        data-layer="cosigner_birth_date_field"
        @input="setDate($event)"
        @reset="handleReset()"
        @filled="handleFilled()"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        @click="next()"
        v-data-layer="handleDataLayer"
      >
        Continue
      </AppButtonContinue>

    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppDateInput from '../inputs/AppDateInput'
import scroll from '@/mixins/scroll'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'
import DataLayer from '../../../../data-layer'

export default {
  name: 'confirm-eligibility',

  components: {
    AppButtonContinue,
    AppDateInput,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  // Mixins
  mixins: [scroll],

  data () {
    return {
      datalayerStepName: 'cosigner',
      dates: [],
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      value: this.initialValue,
      submitted: false,
      isValidDate: false
    }
  },

  computed: {
    dob_day () {
      return this.$store.state.application['dob_day']
    },

    dob_month () {
      return this.$store.state.application['dob_month']
    },

    dob_year () {
      return this.$store.state.application['dob_year']
    },

    error () {
      if (!this.submitted) return
      if (!this.value) return 'This field is required.'
      if (!this.checkDate) return 'Must be a valid date'
      if (!this.checkAge()) return 'Must be between 18 and 99 years old'
    },

    checkDate () {
      let month = this.months.indexOf(this.dob_month) + 1
      let year = +this.dob_year
      return year !== 0 && month >= 1 && month <= 12 && this.dob_day > 0 && this.dob_day <= this.daysInMonth(month, year)
    },

    stepIsValid () {
      return this.checkDate && this.checkAge()
    }
  },

  created () {
    if (!this.value) {
      if (this.months.indexOf(this.dob_month) > -1) {
        let month = this.months.indexOf(this.dob_month) + 1
        month = month.toString().length === 1 ? `0${month}` : month
        this.value = `${month}/${this.dob_day}/${this.dob_year}`
      }
    }
  },

  mounted () {
    if (this.value) this.setDate(this.value)
    if (this.stepIsValid) this.isValidDate = true
  },

  methods: {
    setDate (value) {
      this.submitted = false
      this.isValidDate = false
      this.value = value

      if (value) {
        this.dates = value.replace(/_| /g, '').split('/')
        let day = this.dates[1]
        let monthIndex = parseInt(this.dates[0], 10) - 1
        let year = this.dates[2]

        if (+this.dates[0] > 0 && +this.dates[0] <= 12) {
          this.$store.updateApplication('dob_month', this.months[monthIndex])
        } else {
          this.$store.updateApplication('dob_month', undefined)
        }

        this.$store.updateApplication('dob_day', day)
        this.$store.updateApplication('dob_year', year)
      } else {
        this.$store.updateApplication('dob_day', undefined)
        this.$store.updateApplication('dob_year', undefined)
        this.$store.updateApplication('dob_month', undefined)
      }
    },

    /**
     * Get the number of days in any particular month
     * @link https://stackoverflow.com/a/1433119/1293256
     * @param  {integer} m The month (valid: 0-11)
     * @param  {integer} y The year
     * @return {integer}   The number of days in the month
    */
    daysInMonth (m, y) {
      switch (m) {
        case 2:
          return (y % 4 === 0 && y % 100) || y % 400 === 0 ? 29 : 28
        case 9: case 4: case 6: case 11:
          return 30
        default:
          return 31
      }
    },

    checkAge () {
      const today = new Date()
      const birthDate = new Date()
      birthDate.setFullYear(this.dates[2])
      birthDate.setMonth(this.dates[0] - 1)
      birthDate.setDate(this.dates[1])
      const month = today.getMonth() - birthDate.getMonth()
      let age = today.getFullYear() - birthDate.getFullYear()

      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }
      return age >= 18 && age <= 99
    },

    handleFilled () {
      this.submitted = true
      if (!this.error) {
        this.$store.updateApplication('birth_date', this.value)
        this.isValidDate = true
      }
    },

    handleReset () {
      this.value = undefined
      this.setDate()
      this.submitted = true
    },

    next () {
      this.submitted = true

      if (!this.error && this.isValidDate) {
        this.$emit('next')
      } else {
        this.$nextTick(() => {
          this.$_scroll_toElement('.has-error', 1000)
        })
      }
    },

    handleDataLayer () {
      DataLayer.track({
        birthdate: this.dob_month + '/' + this.dob_day + '/' + this.dob_year,
        event: 'gpa_step_completed',
        is_cosigner: true,
        step: '10'
      })
    }
  }
}
</script>

<style lang="scss">
  .cosigner.date-field label{
    @include breakpoint('mobile-only') {
      top: 4px;
    }
  }
</style>
